import { mergeStyles } from "@fluentui/react/";

export const margin = mergeStyles({
    marginTop: 15
  })
  
  export const btnContainer = mergeStyles({
    display: "flex",
  })